"use strict";

var ENVELOPES = 'Envelopes';
var ENVELOPE_REPRINTS = 'Envelope Reprints';
module.exports = {
  ENVELOPES: ENVELOPES,
  ENVELOPE_REPRINTS: ENVELOPE_REPRINTS
};